import React from "react";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PageHeader = ({ title, showBack = false, onBackClick = null, rightContent = null }) => {
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-30 bg-background/95 backdrop-blur-sm border-b border-border">
      <div className="flex items-center justify-between px-4 py-3 max-w-3xl mx-auto">
        <div className="flex items-center gap-2">
          {showBack && (
            <button
              onClick={onBackClick || (() => navigate(-1))}
              className="p-2 -ml-2 rounded-xl hover:bg-muted transition-colors"
              data-testid="back-btn"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>
          )}
          <h1 className="text-xl font-semibold">{title}</h1>
        </div>
        {rightContent}
      </div>
    </header>
  );
};

export default PageHeader;
